import { PlatformBraze } from '@/src/services/Braze/PlatformBraze'
import '@/src/services/Braze/keepBrazeUserInSyncWithMesaUser'
import { useTokenStore } from '@/src/common/store/useTokenStore'

useTokenStore.subscribe(
  (state) => state.tokens?.accessToken,
  function keepBrazeAuthenticationInSyncWithMesaAuthentication(accessToken) {
    if (accessToken) PlatformBraze.setSdkAuthenticationSignature(accessToken)
  },
)
